import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getAddressByStr } from '@r1-frontend/entities/ContactAddress/selectors/helpers';

import { CallCalling } from '@r1-frontend/ui-react/components/svg/call';
import { Location } from '@r1-frontend/ui-react/components/svg/location';
import { Coin } from '@r1-frontend/ui-react/components/svg/money';
import { User } from '@r1-frontend/ui-react/components/svg/users';

import InfoBlock from '~/src/features/full-buy/InfoBlock';
import InfoBlockItem from '~/src/features/full-buy/InfoBlock/Item';
import { EBonusTypes } from '~/src/features/full-buy/PromoCode';
import { TState } from '~/src/store';

interface IProps {
    agreementNumber: number | null,
}

const AgreementInfo: FC<IProps> = ({ agreementNumber }) => {
    const title = agreementNumber ? `Заявка № ${agreementNumber}` : 'Ваши данные';
    const {
        fio,
        phone,
        address,
        bonusAmount,
        bonusType,
        promoCodeError,
    } = useSelector((state: TState) => ({
        fio: state.contactDetails.editedFio,
        phone: state.contactDetails.confirmedPhone.phone,
        address: state.fullBuy.selectedAddress?.address.value || getAddressByStr(state.contactAddress.verifiedAddressData.address),
        bonusAmount: state.fullBuy.promoCode?.amount,
        bonusType: state.fullBuy.promoCode?.type,
        promoCodeError: state.fullBuy.promoCode?.hasError,
    }));

    const bonusMessage = useMemo(() => {
        return promoCodeError
            ? 'Не удалось активировать промокод — возникла ошибка при регистрации в программе лояльности.'
            : bonusType === EBonusTypes.AMOUNT
                ? `Начислим вам ${bonusAmount} бонусов после визита инженера.`
                : `Начислим вам ${bonusAmount}% от абонентской платы в виде бонусов после визита инженера.`;
    }, [bonusAmount, bonusType, promoCodeError]);

    return (
        <InfoBlock
            title={title}
            header={'Информация'}
            isCollapsable={true}
            isRightSide={true}
            customStyles={{
                wrapper: 'margin-bottom: 40px;',
            }}
        >
            <InfoBlockItem
                icon={<User size={24}/>}
                title={'ФИО'}
                content={fio}
            />
            <InfoBlockItem
                icon={<CallCalling size={24}/>}
                title={'Номер телефона'}
                content={phone}
            />
            <InfoBlockItem
                icon={<Location size={24}/>}
                title={'Адрес подключения'}
                content={address}
            />
            {bonusType !== undefined || promoCodeError
                ? <InfoBlockItem
                    icon={<Coin size={24}/>}
                    title={'Программа лояльности'}
                    content={bonusMessage}
                />
                : <></>
            }
        </InfoBlock>
    );
};

export default AgreementInfo;
